import { useEffect } from 'react';
import { useCookieConsent } from '@/hooks/useCookieConsent';

declare global {
  interface Window {
    fbq: ((...args: unknown[]) => void) & { 
      callMethod?: (...args: unknown[]) => void;
      queue: unknown[];
      push: (...args: unknown[]) => void;
      loaded: boolean;
      version: string;
    };
    _fbq: typeof window.fbq;
  }
}

interface FacebookPixelProps {
  pixelId?: string;
}

export function FacebookPixel({ pixelId = 'PIXEL_ID' }: FacebookPixelProps) {
  const { marketing } = useCookieConsent();

  useEffect(() => {
    // Only load Facebook Pixel if user has given consent and we have a valid ID
    if (!marketing || pixelId === 'PIXEL_ID') return;

    // Check if already loaded
    if (window.fbq) return;

    // Load Facebook Pixel
    const n = window.fbq = function(...args: unknown[]) {
      if (n.callMethod) {
        n.callMethod(...args);
      } else {
        n.queue.push(args);
      }
    } as typeof window.fbq;

    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode?.insertBefore(script, firstScript);

    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');

  }, [marketing, pixelId]);

  return null;
}
